
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from "react-hook-form";
import { ApplicationFormValues } from "./formSchema";

interface CreativeApproachSectionProps {
  form: UseFormReturn<ApplicationFormValues>;
}

export function CreativeApproachSection({ form }: CreativeApproachSectionProps) {
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium">2. Votre Approche Créative (facultatif)</h3>
      
      <FormField
        control={form.control}
        name="creativeApproach"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Décrivez brièvement votre concept créatif</FormLabel>
            <FormControl>
              <Textarea
                placeholder="En quelques phrases, expliquez comment vous envisagez de réinterpréter nos extraits exclusifs"
                className="resize-none min-h-[100px]"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
